<h1 class="Anton">Estudios</h1>

<div class="row">
    <div class="col-2 centrar">
        <h3>INICIAL</h3>
    </div>
    <div class="col-10">
        <div class="tarjeta-estudios">
            <h4>UNIDAD EDUCATIVA RICHARD NIXON</h4>
            <p></p>
        </div>
    </div>
    <div class="col-2 centrar">
        <h3>ESCUELA</h3>
    </div>
    <div class="col-10">
        <div class="tarjeta-estudios">
            <h4>ACADEMIA NAVAL AMAZONAS</h4>
            <hr>
            <div class="row">
                <div class="col-6"><p>Somos una institución educativa paramilitar con prestigio,personal altamente calificado y en constante actualización;dedicados a brindar a nuestros estudiantes una educación integral con iniciatica,creatividad,dinamismo,equidad,autonomía y responsabilidad</p>
                </div>
                <div class="col-6 ajustar-imagen">
                    <img src="https://pbs.twimg.com/media/DHAeRv3XkAEpEcx.jpg" alt="Colegio">
                </div>
            </div>
        </div>
    </div>
    <div class="col-2 centrar">
        <h3>COLEGIO</h3>
    </div>
    <div class="col-10">
        <div class="tarjeta-estudios">
            <h4>ACADEMIA NAVAL AMAZONAS</h4>
            <hr>
            <div class="row">
                <div class="col-6"><p>Somos una institución educativa paramilitar con prestigio,personal altamente calificado y en constante actualización;dedicados a brindar a nuestros estudiantes una educación integral con iniciatica,creatividad,dinamismo,equidad,autonomía y responsabilidad</p>
                </div>
                <div class="col-6 ajustar-imagen">
                    <img src="https://pbs.twimg.com/media/DHAeRv3XkAEpEcx.jpg" alt="Colegio">
                </div>
            </div>
        </div>
    </div>
    <div class="col-2 centrar">
        <h3>UNIVERSIDAD</h3>
    </div>
    <div class="col-10">
        <div class="tarjeta-estudios">
            <h4>UNIVERSIDAD POLITECNICA SALESIANA</h4>
            <hr>
            <div class="row">
                <div class="col-6">
                    <p>La Universidad Politécnica Salesiana es una institución de educación superior humanística y politécnica, de inspiración cristiana con carácter católico e índole salesiana; dirigida de manera preferencial a jóvenes de los sectores populares; busca formar "honrados ciudadanos y buenos cristianos", con excelencia humana y académica, con capacidad investigativa e innovadora, que contribuyan al desarrollo sostenible local y nacional.</p>
                </div>
                <div class="col-6 ajustar-imagen">
                    <img src="https://i.ytimg.com/vi/ZzmIeAV_f6g/maxresdefault.jpg" alt="Colegio">
                </div>
            </div>
        </div>
    </div>
</div>
